import { render, staticRenderFns } from "./ExportReutilizable.vue?vue&type=template&id=0854c56e"
import script from "./ExportReutilizable.vue?vue&type=script&lang=js"
export * from "./ExportReutilizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports